export class Grc {
    motivoTraslado: string;
    descripcionMotivoTraslado: string;
    pesoBrutoBienes: string;
    unidadMedidaPesoBruto: string;
    numeroBultos: string;
    modalidadTraslado: string;
    numeroRucTransportista: string;
    numeroPlacaVehiculo: string;
    tipoDocTransportista: string;
    denominacionTransportador: string;
    tipoDocIdeConductor: string;
    numeroDocIdeConductor: string;
    ubigeoPuntoLlegada: string;
    direccionPuntoLlegada: string;
    ubigeoPuntoPartida: string;
    direccionPuntoPartida: string;
    idTraslado: string;

    constructor(motivoTraslado?: string,
                descripcionMotivoTraslado?: string,
                pesoBrutoBienes?: string,
                unidadMedidaPesoBruto?: string,
                numeroBultos?: string,
                modalidadTraslado?: string,
                numeroRucTransportista?: string,
                numeroPlacaVehiculo?: string,
                tipoDocTransportista?: string,
                denominacionTransportador?: string,
                tipoDocIdeConductor?: string,
                numeroDocIdeConductor?: string,
                ubigeoPuntoLlegada?: string,
                direccionPuntoLlegada?: string,
                ubigeoPuntoPartida?: string,
                direccionPuntoPartida?: string,
                idTraslado?: string
    ) {
        this.motivoTraslado = motivoTraslado;
        this.descripcionMotivoTraslado = descripcionMotivoTraslado;
        this.pesoBrutoBienes = pesoBrutoBienes;
        this.numeroBultos = numeroBultos;
        this.unidadMedidaPesoBruto = unidadMedidaPesoBruto;
        this.modalidadTraslado = modalidadTraslado;
        this.numeroRucTransportista = numeroRucTransportista;
        this.numeroPlacaVehiculo = numeroPlacaVehiculo;
        this.tipoDocTransportista = tipoDocTransportista;
        this.denominacionTransportador = denominacionTransportador;
        this.tipoDocIdeConductor = tipoDocIdeConductor;
        this.numeroDocIdeConductor = numeroDocIdeConductor;
        this.ubigeoPuntoLlegada = ubigeoPuntoLlegada;
        this.direccionPuntoLlegada = direccionPuntoLlegada;
        this.ubigeoPuntoPartida = ubigeoPuntoPartida;
        this.direccionPuntoPartida = direccionPuntoPartida;
        this.idTraslado = idTraslado;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/grc.ts